import { motion } from "framer-motion";
import React from "react";
import { projectExperience } from "../../utils/data";
import { fadeIn, staggerContainer, textVariant } from "../../utils/motion";
import css from "./Experties.module.scss";

const Experties = () => {
  return (
    <motion.section
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
      className={css.wrapper}
    >
      <a className="anchor" id="experties"></a>
      <div
        className={`paddings yPaddings flexCenter innerWidth ${css.container}`}
      >
        <div className={css.leftSide}>
          {projectExperience.map((exp, idx) => {
            return (
              <motion.div
                variants={fadeIn("right", "tween", (idx + 1) * 0.2, 0.7)}
                className={css.exp}
                key={idx}
              >
                <div className="flexCenter" style={{ background: exp.bg }}>
                  <exp.icon size={25} color="white" />
                </div>
                <div className="">
                  <span>{exp.name}</span>
                  <a
                    href="https://github.com/ibrahimafzal"
                    style={{ color: "black", textDecoration: "none" }}
                    target="blank"
                    title="Click to visit"
                  >
                    <p>
                      {exp.projects}{" "}
                      <span
                        style={{
                          color: "gray",
                          textDecoration: "underline",
                          fontSize: "0.9rem",
                        }}
                      >
                        {exp.message}
                      </span>
                    </p>
                  </a>
                </div>
              </motion.div>
            );
          })}
        </div>
        <motion.div variants={textVariant(0.5)} className={css.rightSide}>
          <span className="primaryText">What do I help?</span>
          <div>
            <p className="secondaryText">
              I help businesses and startups build fast, scalable, and
              user-friendly web applications using Next.js, React.js, Node.js,
              Express.js, MongoDB, and PostgreSQL. From backend architecture to
              responsive frontend design, I deliver full-stack solutions that
              streamline workflows, enhance user experience, and accelerate
              digital growth across diverse industries.
            </p>
          </div>
          <div className={`flexCenter ${css.stats}`}>
            <div className={`flexCenter ${css.stat}`}>
              <span className="primaryText">15+</span>
              <span className="secondaryText">Projects completed</span>
            </div>
            {/* <div className={`flexCenter ${css.stat}`}>
              <span className="primaryText">3+</span>
              <span className="secondaryText">Happy Clients</span>
            </div> */}
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Experties;
